import { useTranslation } from "react-i18next";
import {
  RiderModel,
} from "../Api/Models/rider.model";
import {useEffect, useState} from "react";
import {patrollerService} from "../Api/Services/PatrollerService";
import ProfileImage from "./ProfileImage";
import { ArrowUpIcon } from "./Icons/ArrowUpIcon";
import { ArrowDownIcon } from "./Icons/ArrowDownIcon";
import { CarIcon } from "./Icons/CarIcon";
import { MopedIcon } from "./Icons/MopedIcon";
import { CalendarIcon } from "./Icons/CalendarIcon";
import { TickFilledIcon } from "./Icons/TickFilledIcon";

interface ProfileDetailsProps {
  rider: RiderModel;
  gearExchange: boolean;
  hasGear?: boolean;
  gearMissing: number | null;
}

const ProfileDetails: React.FunctionComponent<ProfileDetailsProps> = ({
  rider,
  hasGear,
  gearExchange,
  gearMissing,
}) => {
  const { t } = useTranslation();
  const [isContentVisible, setContentVisible] = useState(false);
  const [latestCheck, setLatestCheck] = useState<string | null>(null);
  const [latestCheckName, setLatestCheckName] = useState<string | null>(null);
    const laravelDateTimeToDMY = (laravelDateTime: string) => {
        var parts = laravelDateTime.split(' ');
        var datePart = parts[0];

        var dateParts = datePart.split('-');
        var year = dateParts[0];
        var month = dateParts[1];
        var day = dateParts[2];

        return day + '-' + month + '-' + year;
    }
  const getVehicleType = () => {
    if (rider.vehicle === 3) {
      return <>
              <CarIcon/> {t('Car')}
            </>;
    }

    if (rider.vehicle === 2) {
      return <>
              <MopedIcon/> {t('Bike')}
            </>;
    }
  };

  const toggleContentVisibility = () => {
    setContentVisible((prev) => !prev);
  };

    useEffect(() => {
        patrollerService.latestCheckDate(rider.riderId).then(({date, name}) => {
            setLatestCheck(date ? laravelDateTimeToDMY(date) : null);
            setLatestCheckName(name ? name : null);
        });
        //eslint-disable-next-line
    }, []);

  return (
      <div>
    <div className="profile-details-card mb-4">
      <div className="flex gap-2 items-center justify-between" onClick={toggleContentVisibility}>
        <div className="flex gap-2 items-center">
          <ProfileImage
            imageUrl={rider.image}
            changeImage={false}
            showRiderId={false}
            riderId={rider.riderId}
          />
          <div>
              {rider.sticker && (
                  <div className="profile-details-card__vehicle-type">
                      Rider sticker: {rider.sticker}
                  </div>
              )}
            <div className="profile-details-card__name">
              {rider.name}
            </div>
            <div className="profile-details-card__vehicle-type">
              {rider.vehicle && (
                <div className="flex gap-1">
                {getVehicleType()}
                </div>
              )}
            </div>
          </div>
        </div>
          
        <div className={`rounded-icon ${!isContentVisible ? "rounded-icon--inverse" : ""}`}>
          {isContentVisible ? <ArrowUpIcon width={14} height={7}/> : <ArrowDownIcon width={14} height={7}/>}
        </div>     
      </div>

      

       {isContentVisible && (<>
          <div className="separator-line separator-line--p10"></div>
          <div className="flex gap-4 justify-between items-center">
            <div className="flex gap-1 items-center">
              <div className="text-primary"><TickFilledIcon/></div>
              <div className="text-light">{t("Rider ID")}:</div>
            </div>
            
            <div>{rider.riderId}</div>
          </div>

          <div className="separator-line separator-line--p10"></div>
          <div className="flex gap-4 justify-between items-center">
            <div className="text-light">{t("3PL")}:</div>
            <div>{rider.tpl_name}</div>
          </div>
        
        {/* TODO::TT egyelőre kivettem
        {rider.profileType === ProfileType.TPATROLLER && (
          
          <img
            src={Police}
            width="25px"
            alt="Police"
            style={{ display: "inline", marginLeft: "5px" }}
          />
        )}
        {rider.profileType === ProfileType.FULL_TIME && (
          <img
            src={FullTime}
            width="25px"
            alt="Police"
            style={{ display: "inline", marginLeft: "5px" }}
          />
        )}
        */}
        
          </>
      )}

      {latestCheck ? (
        <>
          <div className="separator-line separator-line--p10"></div>
          <div className="flex gap-1 text-primary text-small">
              <CalendarIcon/>
              {t('Latest check:')} {latestCheck} {t('by')} {latestCheckName}
          </div>
        </>
      ) : null}
    </div>
          
      </div>
  );
};

export default ProfileDetails;
